import TaskService from "../Task/Task.service";
import TaskStatusService from "../TaskStatus/TaskStatus.service";
export default class ActionPlanService {
    static fromJSON(actionPlan) {
        // @ts-expect-error - TS2739 - Type '{ createdDate: Date; modifiedDate: Date; tasks: any; }' is missing the following properties from type 'ActionPlan': id, title, associatedPeople, resources, percentComplete
        return Object.assign(Object.assign({}, actionPlan), { createdDate: new Date(actionPlan.createdDate), modifiedDate: new Date(actionPlan.modifiedDate), tasks: actionPlan.tasks.map(TaskService.fromJSON) });
    }
    static calculatePercentComplete(tasks) {
        const numValidTasks = tasks.filter((task) => task.status && task.status.id !== TaskStatusService.Cancelled.id).length;
        if (numValidTasks === 0) {
            return numValidTasks;
        }
        return (tasks.filter((task) => task.status.id === TaskStatusService.Completed.id)
            .length / numValidTasks);
    }
    static isOverdue(actionPlan) {
        const percentComplete = ActionPlanService.calculatePercentComplete(actionPlan.tasks);
        const dueDate = ActionPlanService.calculateDueDate(actionPlan.tasks);
        return !!dueDate && dueDate < new Date() && percentComplete < 1;
    }
    static calculateStartDate(tasks) {
        // @ts-expect-error - TS2322 - Type '(number | null | undefined)[]' is not assignable to type 'number[]'.
        const startDates = tasks
            // $FlowFixMe filter will filter out nulls.
            .map((task) => task.startDate && task.startDate.getTime())
            .filter((startDate) => startDate != null);
        if (startDates.length) {
            return new Date(Math.min(...startDates));
        }
        return null;
    }
    static calculateDueDate(tasks) {
        // @ts-expect-error - TS2322 - Type '(number | null | undefined)[]' is not assignable to type 'number[]'.
        const dueDates = tasks
            // $FlowFixMe filter will filter out nulls.
            .map((task) => task.dueDate && task.dueDate.getTime())
            .filter((dueDate) => dueDate != null);
        if (dueDates.length) {
            return new Date(Math.max(...dueDates));
        }
        return null;
    }
}
